// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__gY6pv","header":"ClearentDisclaimer_header__2yudN","inner":"ClearentDisclaimer_inner__37tWw"};